// Lightweight Chronicles (session logs) index.
//
// IMPORTANT:
// - Keep this file metadata-only.
// - Session prose lives in `public/sessions/*.md` and is fetched at runtime.

const sessionsData = [
  { id: 1, title: 'Tithes for the Heir', path: '/sessions/session-1.md' },
  { id: 2, title: 'A Riven Transformation', path: '/sessions/session-2.md' },
  { id: 3, title: 'The Warehouse & The Ledger', path: '/sessions/session-3.md' },
];

export default sessionsData;
